import { render, staticRenderFns } from "./SwitchV2.vue?vue&type=template&id=cccc3814&"
import script from "./SwitchV2.vue?vue&type=script&lang=js&"
export * from "./SwitchV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports